module.exports = __webpack_public_path__ + "static/media/3 (1).341c04e6.webp";